import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import ConditionsGenerales from "../pages/legal/ConditionsGenerales";
import PolitiqueConfidentialite from "../pages/legal/PolitiqueConfidentialite";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/a-propos", element: <About /> },
  { path: "/contact", element: <Contact /> },
  { path: "/conditions-generales", element: <ConditionsGenerales /> },
  { path: "/politique-de-confidentialite", element: <PolitiqueConfidentialite /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
